import axios from 'axios';
import router from '../router'
import { message } from 'ant-design-vue';

const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    baseURL: 'https://tools.transsion.com/toolstation', //线上
    //   baseURL: 'http://10.153.221.123:8081/toolstation',  //后端本机
    // baseURL: 'http://10.150.98.101:8083/toolstation',   //后端测试
    timeout: 5000000
})

service.interceptors.request.use( config => {
    // if(config.method === 'get') {
    //     config.paramsSerializer = function (params) {    
    //       return qs.stringify(params, {arrayFormat: 'repeat'})
    //     }
    // }
    return config;
}, error => {
    // console.log(error);
    return Promise.reject();
})

service.interceptors.response.use(response => {
    if(response.status === 200){
        return response.data;
    }else if(response.status === 201){
        return response.data;    
    } else{
        Promise.reject();
    }
}, error => {    
    // console.log(error.response);
    message.error(error.response.data.msg);
    if(error.response.status === 401){
        router.replace({path:'/ATS/Login'});
    }else if(error.response.status === 403){
        router.replace({path:'/ATS/403'});
    }else{
        console.log(error);
        return Promise.reject();
    }    
})

export default service;